import { reactive,computed } from 'vue';
import Checkbox from '../checkbox/index.vue';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    Checkbox,
  },
  props: {
    icon: {  // placeholder
      type: String,
      default:'icon-add.svg'
    },
    name: {  // placeholder
      type: String,
      default:'Title'
    },
    gamma: {  // placeholder
      type: String,
      default:""
    },
    color: {  // placeholder
      type: String,
      default:""
    },
    brightness: {  // placeholder
      type: String,
      default:""
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
    size:{
      type:String,
      default: "",
    },
    star:{
      type:Boolean,
      default: false,
    }
  },
  setup(props, {emit}) {//emit 傳到複層_emit('update:{function}', val)
    const {icon , isCheck} = props;
    const { t } = useI18n();
    //data
    let state = reactive({

    })

    const iconSrc = computed(()=>{
      if(icon === '') return '';
      return icon.indexOf('http') > -1? icon : require(`@/assets/images/${icon}`)
    })
    // methods
    const onClick = (e) =>{
      emit('onClick',e.value);
    }
    const IsChecked = computed({
      get: () => isCheck,
      set: (val) => {
        emit('update:isCheck', val);
      }
    })
    //mounted
    return {
      state,
      iconSrc,
      onClick,
      IsChecked,
      t
    }
  }
}


